import AppLayout from '../AppLayout'
import StruttureSanitarieSection from './StruttureSanitarieSection'

export default function StruttureSanitariePage() {
  return (
    <AppLayout>
      {({ selectedAmbito, onSelectedAmbitoChange }) => (
        <section className="telemetry-dashboard">
          <div className="telemetry-inner">
            <StruttureSanitarieSection
              selectedAmbitoId={selectedAmbito}
              onSelectedAmbitoChange={onSelectedAmbitoChange}
            />
          </div>
        </section>
      )}
    </AppLayout>
  )
}
